import { registerView, View, ViewComponent } from "@frui.ts/views";
import { observer, Observer } from "mobx-react-lite";
import * as React from "react";
import OmissionNoticeViewModel from "viewModels/notice/omission/omissionNoticeViewModel";
import ExemptionNoticeViewModel from "../../viewModels/notice/exemption/exemptionNoticeViewModel";
import LicensePlateChangeNoticeViewModel from "../../viewModels/notice/licensePlateChange/licensePlateChangeNoticeViewModel";
import RefundRequestNoticeViewModel from "../../viewModels/notice/refundRequest/refundRequestNoticeViewModel";

const NoticeView: ViewComponent<
  OmissionNoticeViewModel | LicensePlateChangeNoticeViewModel | ExemptionNoticeViewModel | RefundRequestNoticeViewModel
> = observer(({ vm }) => {
  return <Observer>{() => <View vm={vm.activeChild} />}</Observer>;
});

registerView(NoticeView, OmissionNoticeViewModel);
registerView(NoticeView, LicensePlateChangeNoticeViewModel);
registerView(NoticeView, ExemptionNoticeViewModel);
registerView(NoticeView, RefundRequestNoticeViewModel);
